"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var core_utilities_1 = require("@syl-editor/core-utilities");
var list_item_1 = require("./list-item");
var NAME = 'ordered_list';
var OrderedList = /** @class */ (function (_super) {
    __extends(OrderedList, _super);
    function OrderedList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = NAME;
        _this.role = 'list';
        _this.content = "(" + list_item_1.LIST_ITEM_NAME + "|" + NAME + ")+";
        _this.tagName = function () { return 'ol'; };
        _this.attrs = {
            start: {
                default: 1
            }
        };
        _this.textMatcher = [
            {
                matcher: /^(\d+)\.\s$/,
                handler: function (match) {
                    return {
                        start: match[1]
                    };
                }
            }
        ];
        _this.parseDOM = [
            {
                tag: 'ol',
                getAttrs: function (dom) {
                    return {
                        start: dom.hasAttribute('start') ? +dom.getAttribute('start') : 1
                    };
                }
            }
        ];
        return _this;
    }
    return OrderedList;
}(core_utilities_1.Block));
exports.OrderedList = OrderedList;
var OrderedListController = /** @class */ (function (_super) {
    __extends(OrderedListController, _super);
    function OrderedListController() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = NAME;
        _this.toolbar = {
            className: 'ordered_list',
            tooltip: 'ordered_list'
        };
        return _this;
    }
    return OrderedListController;
}(core_utilities_1.SylController));
exports.OrderedListController = OrderedListController;
var OrderedListPlugin = /** @class */ (function (_super) {
    __extends(OrderedListPlugin, _super);
    function OrderedListPlugin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = NAME;
        _this.Controller = OrderedListController;
        _this.Schema = OrderedList;
        return _this;
    }
    return OrderedListPlugin;
}(core_utilities_1.SylPlugin));
exports.OrderedListPlugin = OrderedListPlugin;
//# sourceMappingURL=ordered-list.js.map